import { useAccountStore, UserTypeId } from "../../common/account";
import { onlyTmUserTypeIds } from "../../common/enum";

export interface UserListItemDto {
    id: number;
    userName: string;
    firstName: string;
    lastName: string;
    password: string;
    userTypeId: UserTypeId;
    email: string;
    isActive: boolean;
    callCenterId: number | null;
    callCenterName: string | null;
    language: string;
}

export interface UserEditDto {
    id: number | null;
    userName: string;
    firstName: string;
    lastName: string;
    password?: string;
    userTypeId?: UserTypeId;
    email: string;
    isActive: boolean;
    callCenterId: number | null;
    language: string;
    isUserCallCenterProjectsEnabled: boolean;
    userCallCenterProjects: UserCallCenterProjectDto[];
}

export interface UserCallCenterProjectDto {
    callCenterProjectId: number;
}

export interface UserCallCenterProjectEditDto {
    callCenterProjectId: number;
    isEnabled: boolean;
    projectName: string;
}

export interface CallCenterProjectDto {
    id: number;
    callCenterId: number;
    projectName: string;
}

export function newUser(): UserEditDto {
    const account = useAccountStore.getState().data;
    const userTypeId = account?.accessTokenDecoded.userTypeId;
    const callCenterId = account?.accountData.accountInfo.callCenterId ?? null;
    return {
        id: null,
        userName: "",
        firstName: "",
        lastName: "",
        email: "",
        isActive: true,
        callCenterId: userTypeId != null && onlyTmUserTypeIds.includes(userTypeId) ? callCenterId : null,
        language: "",
        isUserCallCenterProjectsEnabled: false,
        userCallCenterProjects: [],
    }
}
